import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Home, Briefcase, GraduationCap, Wallet, User, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n, LangToggle } from "@/context/I18nContext";
import NotificationBell from "@/components/NotificationBell";

const NAV = [
  ["/applicator/dashboard", Home, "dashboard"],
  ["/applicator/jobs", Briefcase, "jobs"],
  ["/applicator/training", GraduationCap, "training"],
  ["/applicator/earnings", Wallet, "earnings"],
  ["/applicator/profile", User, "profile"],
];

export default function ApplicatorLayout() {
  const { t } = useI18n();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-[#080808] pb-20 lg:pb-0" data-testid="applicator-shell">
      <div className="glass sticky top-0 z-40">
        <div className="max-w-[1200px] mx-auto px-5 h-[60px] flex items-center justify-between">
          <button onClick={() => navigate("/applicator/dashboard")} className="flex items-center gap-2"><img src="/errah-logo.png" alt="ERRĀH" className="h-7" /><span className="font-serif tracking-[0.2em] text-sm">ERRĀH</span></button>
          <div className="hidden lg:flex items-center gap-6">
            {NAV.map(([to, Icon, key]) => (
              <button key={to} onClick={() => navigate(to)} className={`text-sm ${pathname === to ? "text-[#C9A45C]" : "text-gray-400 hover:text-white"}`}>{t(key)}</button>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <NotificationBell />
            <LangToggle />
            <button onClick={async () => { await logout(); navigate("/applicator/login"); }} data-testid="applicator-logout" className="text-gray-400 hover:text-white"><LogOut size={18} /></button>
          </div>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-5 py-8"><Outlet /></div>

      {/* mobile bottom nav */}
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[#0A0A0A] border-t border-[#C9A45C]/20 grid grid-cols-5" data-testid="applicator-bottom-nav">
        {NAV.map(([to, Icon, key]) => (
          <button key={to} onClick={() => navigate(to)} data-testid={`bottomnav-${key}`} className={`py-2.5 flex flex-col items-center gap-1 ${pathname === to ? "text-[#C9A45C]" : "text-gray-500"}`}>
            <Icon size={18} /><span className="text-[10px]">{t(key)}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
